import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import PracticeAreas from './components/PracticeAreas';
import Differentials from './components/Differentials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <main>
        <Hero />
        <div className="h-[62px]" />
        <About />
        <PracticeAreas />
        <Differentials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
